import {
  AddCardOutlined as AddCardOutlinedIcon,
  AssignmentReturn as AssignmentReturnIcon,
  Receipt as ReceiptIcon,
  ConfirmationNumber as ConfirmationNumberIcon,
  ShoppingCart as ShoppingCartIcon,
  Inventory as InventoryIcon,
  List as ListIcon,
} from "@mui/icons-material";
import { Stack } from "@mui/material";
import React from "react";
import { isAdmin, isSandbox } from "../../../utils/io";
import NavLink, { ProtectedNavLink } from "./NavLink";

export default function NavSectionTwo() {
  return (
    <Stack>
      {[
        {
          icon: AddCardOutlinedIcon,
          title: "Order Hubs",
          path: "/hub-orders/request",
          permission: "CreateHubOrders",
          isShown: () => !isAdmin(),
        },
        {
          icon: ReceiptIcon,
          title: isAdmin() ? "Hub Orders" : "Order History",
          path: "/hub-orders",
          permission: "ViewHubOrders",
        },
        {
          icon: ShoppingCartIcon,
          title: "Device Orders",
          path: "/device-orders",
        },
        {
          icon: ListIcon,
          title: "Sales Orders",
          path: "/sales-orders",
          permission: "SalesOrders",
          isShown: () => isAdmin(),
        },
        {
          icon: InventoryIcon,
          title: "Purchase Orders",
          path: "/purchase-orders",
          permission: "ViewPurchaseOrders",
        },
        {
          icon: AssignmentReturnIcon,
          title: "Hub Returns",
          path: "/hub-returns",
          permission: "ViewHubReturns",
          isShown: () => !isSandbox(),
        },
        {
          icon: ConfirmationNumberIcon,
          title: "Support Tickets",
          path: "/troubleshoot-tickets",
          permission: "ViewTroubleshootTickets",
          isShown: () => !isSandbox() && isAdmin(),
        },
      ].map((page) => {
        const { permission, ...rest } = page;
        if (permission) {
          return (
            <ProtectedNavLink
              permission={permission}
              key={page.path}
              {...rest}
            />
          );
        }
        return <NavLink key={page.path} {...rest} />;
      })}
    </Stack>
  );
}
